import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import apiRoutes from 'services/apiRoutes';
import Axios from './../../apiConfig/Axios';

//////////////////////////////////////useMutation forgetPassword request//////////////////////////
const fetchForgetRequestFn = async (data: reqForgetPasswordRequestType) => {
  const res = await Axios.post<GlobalApiResponseType<responseForgetPasswordRequestType>>(
    apiRoutes.forgetPassword.Request,
    data
  );
  return res.data;
};

export const useForgetRequest = (
  option?: Omit<
    UseMutationOptions<
      GlobalApiResponseType<responseForgetPasswordRequestType>,
      Error,
      reqForgetPasswordRequestType
    >,
    'mutationKey' | 'mutationFn'
  >
) => {
  return useMutation<
    GlobalApiResponseType<responseForgetPasswordRequestType>,
    Error,
    reqForgetPasswordRequestType
  >(fetchForgetRequestFn, option);
};

//////////////////////////////////////useMutation forgetPassword validation//////////////////////////
const fetchForgetValidationFn = async (
  data: reqForgetPasswordValidationType
) => {
  const res = await Axios.post<GlobalApiResponseType<string>>(
    apiRoutes.forgetPassword.Validation,
    data
  );
  return res.data;
};

export const useForgetValidation = (
  option?: Omit<
    UseMutationOptions<
      GlobalApiResponseType<string>,
      Error,
      reqForgetPasswordValidationType
    >,
    'mutationKey' | 'mutationFn'
  >
) => {
  return useMutation<
    GlobalApiResponseType<string>,
    Error,
    reqForgetPasswordValidationType
  >(fetchForgetValidationFn, option);
};

//////////////////////////////////////useMutation forgetPassword change//////////////////////////
const fetchForgetChangePasswordFn = async (
  data: reqForgetPasswordChangePasswordType
) => {
  const res = await Axios.post<GlobalApiResponseType<string>>(
    apiRoutes.forgetPassword.ChangePassword,
    data
  );
  return res.data;
};

export const useForgetChangePassword = (
  option?: Omit<
    UseMutationOptions<
      GlobalApiResponseType<string>,
      Error,
      reqForgetPasswordChangePasswordType
    >,
    'mutationKey' | 'mutationFn'
  >
) => {
  return useMutation<
    GlobalApiResponseType<string>,
    Error,
    reqForgetPasswordChangePasswordType
  >(fetchForgetChangePasswordFn, option);
};
